module.exports = require("element-ui/lib/locale");